<template>
  <div class="configuration-dialog">
    <el-dialog
      v-el-drag-dialog
      :visible.sync="configurationForm.show"
      title="运行配置"
      width="580px"
      :close-on-click-modal="false"
    >
      <div>
        <el-form :model="form" :rules="rules" :show-message="false" :inline-message="false">
          <span class="prompt mr-top">账号配置</span>

          <div class="account mr-top">
            <el-form-item label="登陆账号" prop="account">
              <el-input v-model="form.dataInfo.account" placeholder="请输入登陆账号" :disabled="!configurationForm.editor" style="width:200px;" />
            </el-form-item>

            <el-form-item label="登陆密码" prop="password" style="margin-left:20px;">
              <el-input v-model="form.dataInfo.password" type="password" placeholder="请输入登陆密码" :disabled="!configurationForm.editor" style="width:200px;" />
            </el-form-item>
          </div>

          <span class="prompt mr-top">模板配置</span>
          <div class="mr-top">
            <span>第一步：请先下载</span>
            <a src="" class="setColorBlue" @click="download"> 模板.xlsx</a>
          </div>

          <div class="mr-top">第二步：按照模版格式填写内容后上传</div>

          <div class="mr-top">
            <el-upload
              :disabled="!configurationForm.editor"
              :headers="{sessionId}"
              :data="{
                taskConfigUuid:form.taskConfigUuid
              }"
              style="width:100%;"
              class="upload-demo"
              :on-success="importSuccess"
              accept=".xls, .xlsx"
              drag
              :file-list="fileName"
              :limit="1"
              :on-remove="onRemove"
              :action="`${request}/api/external-service/task/excelParse`"
              multiple
            >
              <i class="el-icon-upload" />
              <div class="el-upload__text" style="color:#000000;font-weight: 600;">点击或拖拽到此处上传</div>
              <div class="el-upload__tip" style="color:#666666;opacity: 0.8;">支持xls、xlsx格式</div>
            </el-upload>
          </div>

          <span class="prompt mr-top">温馨提示：运行查询页面中下载运行结果</span>
          <el-form-item class="mr-top">
            <el-checkbox-group v-model="form.checkList" :disabled="!configurationForm.editor" @change="statusChange()">
              <!-- <el-checkbox label="保存到云端" /> -->
              <el-checkbox label="发送到指定邮箱" />
            </el-checkbox-group>
          </el-form-item>

          <el-form-item label="指定邮箱地址" prop="email">
            <el-input v-model="form.email" placeholder="请输入邮箱地址" :disabled="!configurationForm.editor" style="width:256px;" />
          </el-form-item>
        </el-form>

      </div>
      <div slot="footer">
        <el-button @click="cancel">取消</el-button>
        <el-button v-show="configurationForm.buttonShow" type="primary" @click="lastStep">上一歩</el-button>
        <el-button v-show="configurationForm.buttonShow && configurationForm.editor" type="primary" @click="createPlan">创建计划</el-button>
        <el-button v-show="!configurationForm.buttonShow" type="primary" @click="runCreate">运行</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import * as commonUtil from '@/utils/commonUtil'
export default {
  props: {
    configurationForm: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      form: {
        email: '',
        dataInfo: {
          account: '',
          password: '',
          fileName: '',
          freightRateInfos: ''
        },
        checkList: ['发送到指定邮箱']
      },
      request: '',
      fileName: [],
      type: '',
      checkedId: '发送到指定邮箱',
      rules: {
        email: [
          {
            required: true
          }
        ],
        account: [
          {
            required: true
          }
        ],
        password: [
          {
            required: true
          }
        ]
      }
    }
  },
  computed: {
    sessionId() {
      return this.$store.getters.token
    }
  },
  methods: {
    // 新增时获取机器人id
    addParams(row) {
      this.form.taskConfigUuid = row.robotName
    },
    // 编辑时直接拿取机器人id
    params(row, type) {
      this.form.taskConfigUuid = row.taskConfigUuid
      if (row.notifyEmail) {
        this.form.email = row.notifyEmail
      }
      this.request = window.location.origin
      if (row.dataInfo) {
        this.form.dataInfo = JSON.parse(row.dataInfo)
        if (this.form.dataInfo.fileName) {
          this.fileName = [{ name: this.form.dataInfo.fileName }]
        }
      }
    },
    // 取消
    cancel() {
      this.$emit('configurationCancel')
      this.reset()
    },
    // 下载文件
    download() {
      window.location.href = '/static/EVG-长荣GreenX报价查询导入模板.xlsx'
    },
    importSuccess(dataInfo, fileList) {
      this.form.dataInfo.fileName = fileList.name
      this.form.dataInfo.freightRateInfos = dataInfo.data.data
    },
    onRemove(data) {
      this.form.dataInfo.fileName = ''
      this.form.dataInfo.freightRateInfos = ''
    },
    // 初始化
    reset() {
      this.form = {
        email: '',
        dataInfo: {
          account: '',
          password: '',
          fileName: '',
          freightRateInfos: ''
        },
        checkList: ['发送到指定邮箱']
      }
      this.fileName = []
      this.checkedId = '发送到指定邮箱'
    },
    // 运行
    runCreate() {
      if (!this.form.email.trim()) {
        this.$message.warning('请输入邮箱地址')
        return
      }
      if (!this.form.dataInfo.account.trim()) {
        this.$message.warning('请输入登陆账号')
        return
      }
      if (!this.form.dataInfo.password.trim()) {
        this.$message.warning('请输入登陆密码')
        return
      }
      const KEY = 'MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAmXOG9cnyANZWpJV5i3bPVX7nVXF4ZM1ounHbbcu5xW39hL9VTxNNjbszzaAJK/bGs9AFSMOaWA9yksCxpGjFgOWcLxaqdZKD0QjvCwxxD3Z1JNH253bm1RME7VoqBms3pK+BHGuCybK3jULIc7vo8b1MUat4EjMp3vVGrbBM9qM/BOgB0XR3SYA7dkdZAoOdLmp1eKTn96gWQOQLio3NFmPKGhvzw3kQXWFOTVr9uCblh95DrWqtqGLI8IiENaSQk3uTCGZzZ7Hxoz7nK0vVnzPUKSkp9zaibwZN+3WfXhMZHrhqGmIfomLjhUuzAjeDZLO8GVkGxbDD3+PSVN0FEwIDAQAB'
      const form = JSON.parse(JSON.stringify(this.form))
      form.password = commonUtil.encryption(KEY, form.password)
      this.$emit('runCreate', form)
    },
    // 上一步
    lastStep() {
      this.$emit('lastStep')
    },
    // 创建计划
    createPlan() {
      if (!this.form.email.trim()) {
        this.$message.warning('请输入邮箱地址')
        return
      }
      if (!this.form.dataInfo.account.trim()) {
        this.$message.warning('请输入登陆账号')
        return
      }
      if (!this.form.dataInfo.password.trim()) {
        this.$message.warning('请输入登陆密码')
        return
      }
      const KEY = 'MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAmXOG9cnyANZWpJV5i3bPVX7nVXF4ZM1ounHbbcu5xW39hL9VTxNNjbszzaAJK/bGs9AFSMOaWA9yksCxpGjFgOWcLxaqdZKD0QjvCwxxD3Z1JNH253bm1RME7VoqBms3pK+BHGuCybK3jULIc7vo8b1MUat4EjMp3vVGrbBM9qM/BOgB0XR3SYA7dkdZAoOdLmp1eKTn96gWQOQLio3NFmPKGhvzw3kQXWFOTVr9uCblh95DrWqtqGLI8IiENaSQk3uTCGZzZ7Hxoz7nK0vVnzPUKSkp9zaibwZN+3WfXhMZHrhqGmIfomLjhUuzAjeDZLO8GVkGxbDD3+PSVN0FEwIDAQAB'
      const form = JSON.parse(JSON.stringify(this.form))
      form.password = commonUtil.encryption(KEY, form.password)
      this.$emit('createPlan', form)
    },
    statusChange() {
      if (this.form.checkList.length > 1 && this.form.checkList.length !== 0) {
        this.form.checkList.splice(0, 1)
        this.checkedId = this.form.checkList[0]
      } else {
        this.form.checkList.push(this.checkedId)
      }
    }
  }
}
</script>
<style lang="scss">
.configuration-dialog {
  .el-form-item__label {
    float: none; // 取消label左浮动
    word-break: break-word; // 支持单词截断换行
  }
  .mr-top {
    margin-top: 15px;
  }
  .setColorBlue{
    color:#1F75D5;
    cursor: pointer;
  }
  .tips{
    width:30px;
    height:30px;
    display: inline-block;
  }
  .account{
    display: flex;
    justify-content: flex-start;
  }
  .prompt{
    width: 100%;
    height: 36px;
    border-radius: 4px;
    background: linear-gradient(135deg,#e9f3fe, #fdfeff);
    color: #333333;
    font-size: 14px;
    line-height: 36px;
    display: inline-block;
    padding-left: 10px;
    font-weight: 500;
  }
  .el-upload,.el-upload-dragger{
    width:100%;
  }
}

</style>
